import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SavedLocation } from '@hero/schema';
import { useSavedLocationDrawerStore } from '@hero/hooks-shared';
import { LocationIcon } from '@hero/web-icons';
import { Card } from '../../../app/Card/Card';
import { Badge } from '../../../ui/Badge';
import { ClientDisplay } from '../../Client';
import { ContactsTooltipDisplay } from '../../Contact';
import { CityName } from '../../../app';

export interface SavedLocationCardProps {
  savedLocation: SavedLocation;
  className?: string;
}

export const SavedLocationCard: React.FC<SavedLocationCardProps> = ({
  savedLocation,
  className,
}) => {
  const { t } = useTranslation(['m-location']);
  const openDrawer = useSavedLocationDrawerStore(s => s.open);

  const locationType = savedLocation.client ? 'for_client' : 'my_location';
  const cityName = savedLocation.address?.city?.name || '';
  return (
    <Card onClick={() => openDrawer(String(savedLocation._id))} className={className}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium text-gray-700 min-w-0">
          <div className="flex items-center justify-center rounded-md bg-gray-50 p-1.5 flex-shrink-0">
            <LocationIcon className="size-3.5 text-gray-400" />
          </div>
          <span className="truncate">{savedLocation.name}</span>
        </div>
        {savedLocation.client ? (
          <ClientDisplay clientName={savedLocation.client.name} />
        ) : (
          <Badge
            variant="outline"
            className="bg-gray-50 text-gray-600 border-gray-200 flex-shrink-0">
            {t(`location_type.${locationType}.title`)}
          </Badge>
        )}
      </div>

      <div className="flex items-center justify-between gap-4 mt-2">
        <CityName city={cityName} />
        <div className="flex items-center gap-2 min-w-0">
          {savedLocation.address?.fullAddress && (
            <p className="text-xs text-muted-foreground truncate">
              {savedLocation.address.fullAddress}
            </p>
          )}
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <ContactsTooltipDisplay contacts={savedLocation.contacts} />
        </div>
      </div>
    </Card>
  );
};
